'use client';

import { TotemCategorySidebar } from '@/features/totems/presentation/components/web-totem/layout/totem-category-sidebar';
import { TotemHeader } from '@/features/totems/presentation/components/web-totem/layout/totem-header';
import { TotemOrderOptionsOverlay } from '@/features/totems/presentation/components/web-totem/layout/totem-order-options-overlay';
import { TotemOrderPanel } from '@/features/totems/presentation/components/web-totem/layout/totem-order-panel';
import { TotemProductGrid } from '@/features/totems/presentation/components/web-totem/layout/totem-product-grid';
import { TotemSearchPill } from '@/features/totems/presentation/components/web-totem/layout/totem-search-pill';
import { useLocationPreference } from '@/features/totems/presentation/hooks/web-totem/use-location-preference';
import { useTotemCartState, useTotemCatalog } from '@/features/totems/presentation/providers/web-totem/totem-provider';
import { cn } from '@/shared/utils/utils';

interface TotemShellProps {
  readOnly?: boolean;
}

export function TotemShell({ readOnly = false }: TotemShellProps) {
  const { totem } = useTotemCatalog();
  const { cart } = useTotemCartState();
  const { data: locationPreference } = useLocationPreference(totem?.location_id ?? undefined);

  return (
    <div className={cn('flex h-dvh w-full flex-col overflow-hidden bg-background')}>
      <TotemHeader />
      {locationPreference?.totem_search && <TotemSearchPill />}
      <div className="relative flex min-h-0 flex-1">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col landscape:flex-row">
          <TotemCategorySidebar />
          <main className="relative flex min-h-0 min-w-0 flex-1 flex-col">
            <TotemProductGrid readOnly={readOnly} />
          </main>
        </div>
        {!readOnly && cart.items.length > 0 && <TotemOrderPanel />}
        {!readOnly && (locationPreference?.take_away || locationPreference?.eat_here) && <TotemOrderOptionsOverlay />}
      </div>
    </div>
  );
}
